import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AppErrorCode, createAppError } from '../errors/app-error';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let code: AppErrorCode;
      let message: string;
      const originMessage = getOriginErrorMessage(error);

      if (error.status === 0) {
        code = 'network';
        message = originMessage || 'Network error. Please check your connection.';
      } else if (error.status === 401) {
        code = 'unauthorized';
        message = originMessage || 'Unauthorized. Please log in again.';
      } else if (error.status === 403) {
        code = 'forbidden';
        message = originMessage || 'Forbidden. You do not have permission.';
      } else if (error.status === 404) {
        code = 'not_found';
        message = originMessage || 'Resource not found.';
      } else if (error.status === 422 || error.status === 400) {
        code = 'validation';
        message = originMessage || 'Validation error';
      } else if (error.status >= 500) {
        code = 'server';
        message = originMessage || 'Server error. Please try again later.';
      } else {
        code = 'unknown';
        message = originMessage || error.message || 'An error occurred';
      }

      return throwError(() => createAppError(code, message));
    }),
  );
};

function getOriginErrorMessage(error: HttpErrorResponse): string | null {
  const errorBody = parseErrorBody(error.error);
  const backendError = errorBody?.errors?.[0] ?? errorBody?.error?.errors?.[0];

  if (backendError?.message) {
    const fieldMsg = backendError.field ? ` (${backendError.field})` : '';
    return `${backendError.message}${fieldMsg}`;
  }

  if (errorBody?.message) {
    return String(errorBody.message);
  }

  if (typeof error.error === 'string') {
    return error.error;
  }

  return null;
}

function parseErrorBody(errorBody: unknown): any {
  if (typeof errorBody !== 'string') {
    return errorBody;
  }

  try {
    return JSON.parse(errorBody);
  } catch {
    return null;
  }
}
